// LaunchDarkly configuration
export const launchDarklyConfig = {
  clientSideID: process.env.PARCEL_LAUNCHDARKLY_SDK_CLIENT_KEY || "",
  options: {
    // Optional configuration settings
    streaming: process.env.NODE_ENV !== "development",
    // Disable event sending in development to avoid CORS issues
    sendEvents: process.env.NODE_ENV !== "development",
    // Use polling instead of streaming in development to avoid CORS issues
    useReport: process.env.NODE_ENV !== "development",
    // Disable console logging in production
    logger:
      process.env.NODE_ENV === "development"
        ? undefined
        : {
            debug: () => {},
            info: () => {},
            warn: () => {},
            error: () => {},
          },
    // Set this to false in test environments to avoid connecting to LaunchDarkly
    // streaming: process.env.NODE_ENV !== 'test',
  },
};

// Default user object - will be overridden when user logs in
export const defaultLDUser = {
  key: "anonymous-user-default-key", // Changed from process.env.LAUNCHDARKLY_SDK_CLIENT_KEY
  anonymous: true,
  // Add custom attributes as needed
  custom: {
    appVersion: process.env.npm_package_version,
  },
};
